import { IN_PERSON_TRAINING } from 'constants/actionTypes';

const initialState = {
  policies: {},
  features: {},
};

export default (state = initialState, action) => {
  if (action.type === IN_PERSON_TRAINING.EVENTS_DASHBOARD.DATA_RECEIVE) {
    return {
      ...state,
      policies: action.payload.meta.policies,
      features: action.payload.meta.features,
    };
  }
  return state;
};
